import React from 'react';
import LoginForm from '../../components/login/LoginForm';
import '../../styles/loginPage/login.css';

const LoginPage = () => {
  return (
    <>
        <div className="login-container">
        <LoginForm/>
        </div>
        
    </>
  )
}

export default LoginPage